import React from "react";
import { Link } from "react-router-dom";
import { Home, Search } from "lucide-react";
import SEO from "../components/SEO";

const NotFound: React.FC = () => {
  return (
    <>
      <SEO
  title="Page Not Found"
  description="The page you are looking for does not exist."
  noIndex
/>



      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-sky-50 via-blue-50 to-indigo-100 px-4">
        <div className="max-w-xl w-full bg-white/80 backdrop-blur-xl rounded-3xl shadow-xl border border-gray-200 p-10 md:p-14 text-center">

          {/* Big 404 */}
          <h1 className="text-[96px] md:text-[120px] font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-sky-500 to-blue-600 leading-none mb-4">
            404
          </h1>

          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3">
            Page Not Found
          </h2>

          <p className="text-gray-600 mb-8">
            Oops! The page you’re looking for doesn’t exist or has been moved.
          </p>

          {/* Actions */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/">
              <button className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-xl bg-gradient-to-r from-sky-500 to-blue-600 text-white font-semibold shadow hover:shadow-lg transition">
                <Home className="w-4 h-4" />
                Go Home
              </button>
            </Link>

            <Link to="/templates">
              <button className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-xl border border-gray-300 bg-white text-gray-800 font-medium hover:bg-gray-100 transition">
                <Search className="w-4 h-4" />
                Browse Themes
              </button>
            </Link>
          </div>

          <p className="mt-8 text-sm text-gray-500">
            TheCodeBazaar.com
          </p>
        </div>
      </div>
    </>
  );
};

export default NotFound;
